module.exports = __webpack_public_path__ + "static/media/Logo.67c87854.png";